'use client';

import { createContext, useContext, useState, ReactNode } from 'react';

type ViewMode = 'simple' | 'expert';

const ViewModeContext = createContext<{
    mode: ViewMode;
    toggle: () => void;
}>({ mode: 'simple', toggle: () => { } });

export function ViewModeProvider({ children }: { children: ReactNode }) {
    const [mode, setMode] = useState<ViewMode>('simple');
    const toggle = () => setMode(m => m === 'simple' ? 'expert' : 'simple');
    return (
        <ViewModeContext.Provider value={{ mode, toggle }}>
            {children}
        </ViewModeContext.Provider>
    );
}

export function useViewMode() {
    return useContext(ViewModeContext);
}
